import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../environments/environment';
@Injectable({
  providedIn: 'root'
})


export class MapDetailService {
  constructor(private http: HttpClient) {
  }

  getThsr(dire:string) {
    const params: any = {dire:dire};
    return this.http.get(environment.url +'/mapDetail/getThsr', {params} );
  }

  getTra(stationId:string) {
    const params: any = {stationId:stationId};
    return this.http.get(environment.url +'/mapDetail/getTra', {params} );
  }

  getBus(stationId:string) {
    const params: any = {stationId:stationId};
    return this.http.get(environment.url +'/mapDetail/getBus', {params} );
  }

  getNhpt(stationId:string) {
    const params: any = {stationId:stationId};
    return this.http.get(environment.url +'/mapDetail/getNhpt', {params} );
  }

  getBike(stationId:string) {
    const params: any = {stationId:stationId};
    return this.http.get(environment.url +'/mapDetail/getBike', {params} );
  }


}
